// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__z-Vz4","extraText":"TextArea_extraText__LKrI+"};